/**
 * Points d’entrée routeur éditeur de bloc :
 * - `/content/content-block/new?pageId&widgetId` → création ;
 * - `/content/content-block/:workspaceId` → édition d’une instance existante.
 */
import { getRouteApi } from '@tanstack/react-router';
import { ContentBlockEditorView } from '@admin/components/personalization/content-block-editor-view.tsx';
import {
  useContentBlockEditor,
  type ContentBlockEditorProps
} from '@admin/pages/personalization/use-content-block-editor.ts';

/** Branche logique (`useContentBlockEditor`) et UI (`ContentBlockEditorView`). */
function ContentBlockEditor(props: ContentBlockEditorProps) {
  const editor = useContentBlockEditor(props);
  return <ContentBlockEditorView {...editor} />;
}

const contentBlockEditRouteApi = getRouteApi('/auth-layout/content/content-block/$workspaceId');
const contentBlockNewRouteApi = getRouteApi('/auth-layout/content/content-block/new');

export function ContentBlockEditPage() {
  const { workspaceId } = contentBlockEditRouteApi.useParams();
  return <ContentBlockEditor mode="edit" workspaceId={Number(workspaceId)} />;
}

export function ContentBlockNewPage() {
  const { pageId, widgetId } = contentBlockNewRouteApi.useSearch();
  return <ContentBlockEditor mode="create" pageId={pageId} widgetId={widgetId} />;
}
